export const createCustomErrorWithOriginal = (
  errorName: string,
): new (message: string, originalError?: Error | unknown) => Error => {
  return class extends Error {
    public originalError?: Error;

    constructor(message: string, originalError?: Error | unknown) {
      super(message);
      this.name = errorName;

      // Copy stack trace from original error if available
      if (originalError && originalError instanceof Error) {
        this.originalError = originalError;
        this.stack = originalError.stack;
        this.message = `${message}: ${originalError.message}`;
      }

      // Maintain proper prototype chain
      Object.setPrototypeOf(this, new.target.prototype);
    }
  };
};
